import React from "react";

import { StaffSelection } from "@/components/CommisstionSetting/StaffSelection";
import { setSettingByKey } from "@/features/commissionSlice";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import _ from "lodash";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
export default function MutiLocationFormRow({ promoterOption }) {
  const dispatch = useDispatch();
  const mutiLocations = useSelector(
    (state) => state.commission.settings.mutiLocations,
    shallowEqual,
  );
  const handlePromoterFormData = React.useCallback(
    async (value) => {
      const cloneRow = _.cloneDeep(mutiLocations);
      cloneRow.promoter = value;
      dispatch(
        setSettingByKey({
          key: "mutiLocations",
          value: cloneRow,
        }),
      );
    },
    [dispatch, mutiLocations],
  );
  return (
    <React.Fragment>
      <Box component="section" spacing={2} sx={{ paddingX: 10 }}>
        <Stack
          sx={{ my: 2 }}
          direction={"row"}
          divider={<Divider orientation="vertical" flexItem variant="middle" />}
          spacing={5}
        >
          <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <StaffSelection
              formDetail={mutiLocations}
              handlePromoterFormData={handlePromoterFormData}
              staffOptions={promoterOption}
            ></StaffSelection>
          </Box>
        </Stack>
      </Box>
    </React.Fragment>
  );
}
